/* eslint-disable arrow-body-style */
export const getFetch = () => fetch;
